import FeatureFlagProvider from './FeatureFlagProvider';

export default FeatureFlagProvider;
